export enum SUMMARY_STAGE {
  START = 'start',
  SLIDES = 'slides',
}
export enum CUSTOMER_TYPE {
  INTERN = 'intern',
  COMMANDER = 'commander',
  LEGEND = 'legend',
  GOD = 'god',
}
export enum SUMMARY_SLIDES {
  TTV = 'ttv',
  FP = 'fp',
  TPNL = 'tPnl',
  TPL = 'tpl',
  TLPFE = 'tLPFE',
}
export const CUSTOMER_GOD_THRESHHOLD = 50000;
export const CUSTOMER_LEGEND_THRESHHOLD = 10000;
export const CUSTOMER_COMMANDER_THRESHHOLD = 5000;
